import { CssBaseline, ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { ja } from "date-fns/locale/ja";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./app/configs/i18n";
import "./app/fetch";
import * as Sentry from "@sentry/react";
import { SnackbarProvider } from "notistack";
import { customTheme } from "./app/configs/mui";
import { routeTree } from "./routeTree.gen";

// Create a new router instance
const router = createRouter({ routeTree });
if (import.meta.env.VITE_APP_ENV === "production") {
  Sentry.init({
    dsn: "https://9bda7d4072a0d61c72b92af68e036d19@o4505923201925120.ingest.us.sentry.io/4508639644811264",
    environment: import.meta.env.VITE_APP_ENV,
    integrations: [],
  });
}

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Render the app
const rootElement = document.getElementById("root");
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
          <ThemeProvider theme={customTheme}>
            <SnackbarProvider>
              <CssBaseline />
              <RouterProvider router={router} />
            </SnackbarProvider>
          </ThemeProvider>
        </LocalizationProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
}
